import { render } from "./ConfirmDeclineModal.vue?vue&type=template&id=7e28f5b0"
import script from "./ConfirmDeclineModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeclineModal.vue?vue&type=script&lang=js"
script.render = render

export default script